import API from '@/services/API'

export async function getLikedBenefits(ctx: any, page = 1) {
    const query = await API.getLikedBenefits(page)

    if (page === 1) {
        await ctx.commit('LIKED_BENEFITS_STARTING')
    }
    await ctx.commit(page === 1 ? 'SET_LIKED_BENEFITS' : 'ADD_LIKED_BENEFITS', query.data)

    if (query.meta.pager?.nbPages !== undefined && query.meta.pager?.nbPages > page) {
        return await ctx.dispatch('getLikedBenefits', page + 1)
    } else {
        await ctx.commit('LIKED_BENEFITS_COMPLETED')
    }
}
